var map = {
	"./attack.svg": "05fa",
	"./block.svg": "cd25",
	"./cost.svg": "0a6d",
	"./heroclasses/covert.svg": "7b75",
	"./heroclasses/instinct.svg": "ddea",
	"./heroclasses/ranged.svg": "86f7",
	"./heroclasses/strength.svg": "4d93",
	"./heroclasses/tech.svg": "5501",
	"./piercing.svg": "5c49",
	"./rarity/common.svg": "3079",
	"./rarity/rare.svg": "2ce7",
	"./rarity/uncommon.svg": "a16d",
	"./recruit.svg": "1b34",
	"./sets/2099.svg": "4c8c",
	"./sets/3d.svg": "1df4",
	"./sets/annihilation.svg": "d585",
	"./sets/antman.svg": "87e3",
	"./sets/blackpanther.svg": "77f1",
	"./sets/blackwidow.svg": "7a47",
	"./sets/captainamerica.svg": "4fb6",
	"./sets/champions.svg": "50e4",
	"./sets/civilwar.svg": "b1a3",
	"./sets/coreset.svg": "1db9",
	"./sets/coreset2.svg": "c117",
	"./sets/darkcity.svg": "5802",
	"./sets/deadpool.svg": "b1d9",
	"./sets/dimensions.svg": "7fd9",
	"./sets/doctorstrange.svg": "6310",
	"./sets/fearitself.svg": "5fed",
	"./sets/ff.svg": "b2eb",
	"./sets/gotg.svg": "29e7",
	"./sets/heroesofasgard.svg": "c8eb",
	"./sets/intothecosmos.svg": "68e2",
	"./sets/marvelstudios.svg": "c2ab",
	"./sets/messiahcomplex.svg": "64ba",
	"./sets/midnightsons.svg": "a8ff",
	"./sets/msaw.svg": "9429",
	"./sets/msgotg.svg": "611a",
	"./sets/msis.svg": "63b9",
	"./sets/mswi.svg": "e5fc",
	"./sets/newmutants.svg": "c4fb",
	"./sets/noir.svg": "b161",
	"./sets/promo.svg": "fd00",
	"./sets/pttr.svg": "62df",
	"./sets/realmofkings.svg": "bacd",
	"./sets/revelations.svg": "a120",
	"./sets/shield.svg": "7c8c",
	"./sets/spiderhomecoming.svg": "a61a",
	"./sets/sw1.svg": "2486",
	"./sets/sw2.svg": "a742",
	"./sets/venom.svg": "801d",
	"./sets/villains.svg": "daf7",
	"./sets/weaponx.svg": "f88e",
	"./sets/wwhulk.svg": "1978",
	"./sets/xmen.svg": "c69d",
	"./teams/avengers.svg": "dc30",
	"./teams/brotherhood.svg": "6fde",
	"./teams/cabal.svg": "5f06",
	"./teams/champions.svg": "caae",
	"./teams/crime-syndicate.svg": "aa50",
	"./teams/fantastic-four.svg": "da7b",
	"./teams/foes-of-asgard.svg": "d8d5",
	"./teams/guardians-of-the-galaxy.svg": "5d34",
	"./teams/guardians-of-the-multiverse.svg": "ee67",
	"./teams/heroes-of-asgard.svg": "9181",
	"./teams/heroes-of-wakanda.svg": "7cec",
	"./teams/hydra.svg": "5fa5",
	"./teams/illuminati.svg": "758c",
	"./teams/inhumans.svg": "3d49",
	"./teams/marvel-knights.svg": "d7af",
	"./teams/mercs-for-money.svg": "a893",
	"./teams/new-warriors.svg": "e00a",
	"./teams/shield.svg": "60b1",
	"./teams/sinister-six.svg": "cfb5",
	"./teams/spider-friends.svg": "e704",
	"./teams/unaffiliated.svg": "2b2a",
	"./teams/venomverse.svg": "025f",
	"./teams/warbound.svg": "aaf4",
	"./teams/x-factor-investigations.svg": "b94a",
	"./teams/x-force.svg": "f59a",
	"./teams/x-men.svg": "bce5",
	"./token.svg": "69f8",
	"./vp.svg": "52e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";